import { all, Div, H3, reactive, Span, VArray } from 'alkali'
import Dropdown from 'components/generic/Dropdown'
import * as closeIcon from 'icons/close.svg'
import Icon from 'components/Icon'
import { patch } from 'tools/request'
import app from '../../app/app'
const interventionCollections = reactive([])

export class TermEditorDropdown extends Dropdown.with('.term-dropdown') {
	alternateLabels: []
	term: {}
	type: string
	ready({ selected }) {
		this.type = reactive('')
		this.items = [
		{
			content: 'Cancel',
			onclick() {

			}
		},
		{
			content: 'Never use',
			onclick: () => {
				this.updateTerm({
					hidden: true,
					reason: 'Not Quantifiable',
				})
			}
		},
		{
			content: this.type.to(type => 'Not ' + type),
			onclick: () => {
				this.updateTerm({
					hidden: this.type.valueOf(),
					reason: 'Not Applicable',
				})
			}
		},
		{
			content: 'Choose preferred label:',
			onclick: () => {
				let newLabel = prompt('Enter new label for ' + this.term.label)
				if (newLabel)
					this.updateTerm({
						label: newLabel,
					})
			}
		},/*
		{
			content: 'Add synonym:',
			onclick: () => {
				let synonym = prompt('Enter new synonym for ' + this.term.label)
				if (synonym)
					this.updateTerm({
						synonyms: this.term.name,
					}, synonym)
			}
		}*/]
	}
	show(event) {
		super.show(event)
	}
	updateTerm(properties, id?) {
		patch('/portal/Term/' + (id || this.term.id || this.term.termId), {
			data: properties
		}).then(() => {
			alert('Updated, refresh to see changes')
		})
		}
	}
